import { useAuthentication } from '@bestseller-bit/frontend-community.utilities.authentication';
import { useMemo } from 'react';
import { useDevTools } from '../devtools/useDevTools';

export const useMsalRoles = () => {
    const { isImpersonating, impersonateRoles } = useDevTools();
    const { account } = useAuthentication();

    const roles = useMemo(() => {
        if (isImpersonating) {
            return impersonateRoles;
        }
        return account?.idTokenClaims?.roles ?? [];
    }, [account?.idTokenClaims?.roles, impersonateRoles, isImpersonating]);

    return roles;
};
